// extracted by mini-css-extract-plugin
export default {"root":"TabsList_root__kF47n"};